<template>
  <a-modal
    title="同步训练"
    :width="800"
    v-model="visible"
    :footer="null"
  >
    <div>
      <a-row :gutter="16">
        <a-col
          :span="12"
          align="center"
        >
          <a-card
            hoverable
            style="width: 300px;background:rgb(230, 247, 255);"
            align="center"
          >
            <img
              src="@/assets/syn/cysj.png"
              width="120"
            />
            <template
              class="ant-card-actions"
              slot="actions"
            >
              <div @click="goStudycysj">
                <a-icon type="edit" /> 开始练习</div>
            </template>
            <a-card-meta
              title="词语速记"
              description="完成20%"
              style="margin-top:20px;"
            >
            </a-card-meta>
            <!-- <div style="margin-top:20px;">
              <a-rate :defaultValue="1" disabled />
            </div> -->
          </a-card>
        </a-col>
        <a-col
          :span="12"
          align="center"
        >
          <a-card
            hoverable
            style="width: 300px;background:rgb(230, 247, 255);"
            align="center"
            @click="goStudy"
          >
            <img
              src="@/assets/syn/znts.png"
              width="120"
            />
            <template
              class="ant-card-actions"
              slot="actions"
            >
              <div @click="goStudy">
                <a-icon type="edit" /> 开始练习</div>
            </template>
            <a-card-meta
              title="智能听说"
              description="完成60%"
              style="margin-top:20px;"
            >
            </a-card-meta>
            <!-- <div style="margin-top:20px;">
              <a-rate :defaultValue="3" disabled />
            </div> -->
          </a-card>
        </a-col>
      </a-row>
      <a-row
        :gutter="16"
        style="margin-top:30px;"
      >
        <a-col
          :span="12"
          align="center"
        >
          <a-card
            hoverable
            style="width:300px;background:rgb(230, 247, 255);"
            align="center"
          >
            <img
              src="@/assets/syn/tstb.png"
              width="120"
            />
            <template
              class="ant-card-actions"
              slot="actions"
            >
              <div @click="goListenSyn">
                <a-icon type="edit" /> 开始练习</div>
            </template>
            <a-card-meta
              title="听说同步"
              description="完成100%"
              style="margin-top:20px;"
            >
            </a-card-meta>
            <!-- <div style="margin-top:20px;">
              <a-rate :defaultValue="5" disabled />
            </div> -->
          </a-card>
        </a-col>
        <a-col
          :span="12"
          align="center"
        >
          <a-card
            hoverable
            style="width: 300px;background:rgb(230, 247, 255);"
            align="center"
          >
            <img
              src="@/assets/syn/dxtb.png"
              width="120"
            />
            <template
              class="ant-card-actions"
              slot="actions"
            >
              <div @click="goReadSyn">
                <a-icon type="edit" /> 开始练习</div>
            </template>
            <a-card-meta
              title="读写同步"
              description="完成40%"
              style="margin-top:20px;"
            >
            </a-card-meta>
            <!-- <div style="margin-top:20px;">
              <a-rate :defaultValue="2" disabled />
            </div> -->
          </a-card>
        </a-col>
      </a-row>
    </div>
  </a-modal>
</template>
<script>

export default {
  name: 'SyncModal',
  data () {
    return {
      visible: false
    }
  },
  created () {
  },
  methods: {
    // 出版社管理
    handlePress () {
      this.visible = true
    },
    handlePressChange (value, key, column) {
      const newData = [...this.data]
      const target = newData.filter(item => key === item.key)[0]
      if (target) {
        target[column] = value
        this.data = newData
      }
    },
    goStudy () {
      this.visible = false
      this.$router.push({ name: 'AIHearsay' })
    },
    goStudycysj () {
      this.visible = false
      this.$router.push({ name: 'bookUnit' })
    },
    goListenSyn () {
      this.visible = false
      this.$router.push({ name: 'HearSyn' })
    },
    goReadSyn () {
      this.visible = false
      this.$router.push({ name: 'ReadSyn' })
    }
  }
}
</script>

<style scoped>
</style>
